import { render, staticRenderFns } from "./Consults.vue?vue&type=template&id=5ea5315c"
import script from "./Consults.vue?vue&type=script&lang=js"
export * from "./Consults.vue?vue&type=script&lang=js"
import style0 from "./Consults.vue?vue&type=style&index=0&id=5ea5315c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports